export var Storage_ErrCode = function () {
  //__ENUM_IIFE__
  var Storage_ErrCode;

  (function (Storage_ErrCode) {
    Storage_ErrCode[Storage_ErrCode["Success"] = 0] = "Success";
    Storage_ErrCode[Storage_ErrCode["ErrStorageTypeOnlySupportedQiniu"] = 26001] = "ErrStorageTypeOnlySupportedQiniu";
    Storage_ErrCode[Storage_ErrCode["ErrUploadFail"] = 26002] = "ErrUploadFail";
    Storage_ErrCode[Storage_ErrCode["ErrAppIdNotFound"] = 26003] = "ErrAppIdNotFound";
    Storage_ErrCode[Storage_ErrCode["ErrQiniuNoSuchFileOrDirectory"] = 26004] = "ErrQiniuNoSuchFileOrDirectory";
    Storage_ErrCode[Storage_ErrCode["ErrTimeout"] = 26005] = "ErrTimeout";
    Storage_ErrCode[Storage_ErrCode["ErrResourceNotFound"] = 26010] = "ErrResourceNotFound";
    Storage_ErrCode[Storage_ErrCode["ErrResourceConfigNotFound"] = 26011] = "ErrResourceConfigNotFound";
    Storage_ErrCode[Storage_ErrCode["ErrStorageTypeNotSupport"] = 26012] = "ErrStorageTypeNotSupport";
    Storage_ErrCode[Storage_ErrCode["ErrInvalidParam"] = 26013] = "ErrInvalidParam";
    Storage_ErrCode[Storage_ErrCode["ErrConfigNotFound"] = 26014] = "ErrConfigNotFound";
    Storage_ErrCode[Storage_ErrCode["ErrConfigMiss"] = 26015] = "ErrConfigMiss";
    Storage_ErrCode[Storage_ErrCode["ErrResourceConflict"] = 26016] = "ErrResourceConflict";
    Storage_ErrCode[Storage_ErrCode["ErrInvalidResourceState"] = 26017] = "ErrInvalidResourceState";
    Storage_ErrCode[Storage_ErrCode["ErrInvalidRequest"] = 26018] = "ErrInvalidRequest";
    Storage_ErrCode[Storage_ErrCode["ErrInvalidBucketAcl"] = 26019] = "ErrInvalidBucketAcl";
    Storage_ErrCode[Storage_ErrCode["ErrInvalidConfig"] = 26020] = "ErrInvalidConfig";
    Storage_ErrCode[Storage_ErrCode["ErrConfigConflict"] = 26021] = "ErrConfigConflict";
    Storage_ErrCode[Storage_ErrCode["ErrInvalidContentType"] = 26022] = "ErrInvalidContentType";
    Storage_ErrCode[Storage_ErrCode["ErrNoSuchFileOrDirectory"] = 26023] = "ErrNoSuchFileOrDirectory";
    Storage_ErrCode[Storage_ErrCode["ErrInvalidTaskType"] = 26024] = "ErrInvalidTaskType";
    Storage_ErrCode[Storage_ErrCode["ErrUnsupportedTaskArgs"] = 26025] = "ErrUnsupportedTaskArgs";
    Storage_ErrCode[Storage_ErrCode["ErrTaskNotFound"] = 26026] = "ErrTaskNotFound";
    Storage_ErrCode[Storage_ErrCode["ErrInvalidTask"] = 26027] = "ErrInvalidTask";
    Storage_ErrCode[Storage_ErrCode["ErrGetDownloadUrlFail"] = 26028] = "ErrGetDownloadUrlFail";
    Storage_ErrCode[Storage_ErrCode["ErrAliyunRequestErr"] = 26029] = "ErrAliyunRequestErr";
    Storage_ErrCode[Storage_ErrCode["ErrTcRequestErr"] = 26030] = "ErrTcRequestErr";
    Storage_ErrCode[Storage_ErrCode["ErrImageTooLarge"] = 26031] = "ErrImageTooLarge";
  })(Storage_ErrCode || (Storage_ErrCode = {}));

  return Storage_ErrCode;
}(); // 转码方案

export var Storage_TranscodeType = function () {
  //__ENUM_IIFE__
  var Storage_TranscodeType;

  (function (Storage_TranscodeType) {
    Storage_TranscodeType[Storage_TranscodeType["TranscodeTypeNil"] = 0] = "TranscodeTypeNil";
    Storage_TranscodeType[Storage_TranscodeType["TranscodeTypeTvsNews"] = 1] = "TranscodeTypeTvsNews";
    Storage_TranscodeType[Storage_TranscodeType["TranscodeTypeTvsNewsReportNews"] = 2] = "TranscodeTypeTvsNewsReportNews";
  })(Storage_TranscodeType || (Storage_TranscodeType = {}));

  return Storage_TranscodeType;
}();
export var Storage_ModelConfig_StorageType = function () {
  //__ENUM_IIFE__
  var Storage_ModelConfig_StorageType;

  (function (Storage_ModelConfig_StorageType) {
    Storage_ModelConfig_StorageType[Storage_ModelConfig_StorageType["StorageTypeNil"] = 0] = "StorageTypeNil";
    Storage_ModelConfig_StorageType[Storage_ModelConfig_StorageType["StorageTypeQiniu"] = 1] = "StorageTypeQiniu";
    Storage_ModelConfig_StorageType[Storage_ModelConfig_StorageType["StorageTypeTCCloud"] = 2] = "StorageTypeTCCloud";
    Storage_ModelConfig_StorageType[Storage_ModelConfig_StorageType["StorageTypeAliyun"] = 3] = "StorageTypeAliyun";
    Storage_ModelConfig_StorageType[Storage_ModelConfig_StorageType["StorageTypeMinIO"] = 4] = "StorageTypeMinIO";
    Storage_ModelConfig_StorageType[Storage_ModelConfig_StorageType["StorageTypeS3"] = 5] = "StorageTypeS3";
  })(Storage_ModelConfig_StorageType || (Storage_ModelConfig_StorageType = {}));

  return Storage_ModelConfig_StorageType;
}();
export var Storage_ModelConfig_BucketAcl = function () {
  //__ENUM_IIFE__
  var Storage_ModelConfig_BucketAcl;

  (function (Storage_ModelConfig_BucketAcl) {
    Storage_ModelConfig_BucketAcl[Storage_ModelConfig_BucketAcl["BucketAclNil"] = 0] = "BucketAclNil";
    Storage_ModelConfig_BucketAcl[Storage_ModelConfig_BucketAcl["BucketAclPublic"] = 1] = "BucketAclPublic";
    Storage_ModelConfig_BucketAcl[Storage_ModelConfig_BucketAcl["BucketAclPublicRead"] = 2] = "BucketAclPublicRead";
    Storage_ModelConfig_BucketAcl[Storage_ModelConfig_BucketAcl["BucketAclPrivate"] = 3] = "BucketAclPrivate";
  })(Storage_ModelConfig_BucketAcl || (Storage_ModelConfig_BucketAcl = {}));

  return Storage_ModelConfig_BucketAcl;
}();
export var Storage_ModelConfig_FreqBlockType = function () {
  //__ENUM_IIFE__
  var Storage_ModelConfig_FreqBlockType;

  (function (Storage_ModelConfig_FreqBlockType) {
    Storage_ModelConfig_FreqBlockType[Storage_ModelConfig_FreqBlockType["FreqBlockTypeNil"] = 0] = "FreqBlockTypeNil";
    Storage_ModelConfig_FreqBlockType[Storage_ModelConfig_FreqBlockType["FreqBlockTypeIp"] = 1] = "FreqBlockTypeIp";
    Storage_ModelConfig_FreqBlockType[Storage_ModelConfig_FreqBlockType["FreqBlockTypeUid"] = 2] = "FreqBlockTypeUid";
  })(Storage_ModelConfig_FreqBlockType || (Storage_ModelConfig_FreqBlockType = {}));

  return Storage_ModelConfig_FreqBlockType;
}();
export var Storage_ModelResource_State = function () {
  //__ENUM_IIFE__
  var Storage_ModelResource_State;

  (function (Storage_ModelResource_State) {
    Storage_ModelResource_State[Storage_ModelResource_State["StateNil"] = 0] = "StateNil";
    Storage_ModelResource_State[Storage_ModelResource_State["StatePending"] = 1] = "StatePending";
    Storage_ModelResource_State[Storage_ModelResource_State["StateSuccess"] = 2] = "StateSuccess";
    Storage_ModelResource_State[Storage_ModelResource_State["StateFail"] = 3] = "StateFail";
  })(Storage_ModelResource_State || (Storage_ModelResource_State = {}));

  return Storage_ModelResource_State;
}();
export var Storage_ModelResourceTask_State = function () {
  //__ENUM_IIFE__
  var Storage_ModelResourceTask_State;

  (function (Storage_ModelResourceTask_State) {
    Storage_ModelResourceTask_State[Storage_ModelResourceTask_State["StateNil"] = 0] = "StateNil";
    Storage_ModelResourceTask_State[Storage_ModelResourceTask_State["StatePending"] = 1] = "StatePending";
    Storage_ModelResourceTask_State[Storage_ModelResourceTask_State["StateSuccess"] = 2] = "StateSuccess";
    Storage_ModelResourceTask_State[Storage_ModelResourceTask_State["StateFail"] = 3] = "StateFail";
  })(Storage_ModelResourceTask_State || (Storage_ModelResourceTask_State = {}));

  return Storage_ModelResourceTask_State;
}();
export var Storage_ModelResourceTask_TaskType = function () {
  //__ENUM_IIFE__
  var Storage_ModelResourceTask_TaskType;

  (function (Storage_ModelResourceTask_TaskType) {
    Storage_ModelResourceTask_TaskType[Storage_ModelResourceTask_TaskType["TaskTypeNil"] = 0] = "TaskTypeNil";
    Storage_ModelResourceTask_TaskType[Storage_ModelResourceTask_TaskType["TaskTypeVideoTranscode"] = 1] = "TaskTypeVideoTranscode";
    Storage_ModelResourceTask_TaskType[Storage_ModelResourceTask_TaskType["TaskTypeVideoSnapshot"] = 2] = "TaskTypeVideoSnapshot";
  })(Storage_ModelResourceTask_TaskType || (Storage_ModelResourceTask_TaskType = {}));

  return Storage_ModelResourceTask_TaskType;
}(); // @ignore: all

export var Storage_ModelResourceTask_TaskSubType = function () {
  //__ENUM_IIFE__
  var Storage_ModelResourceTask_TaskSubType;

  (function (Storage_ModelResourceTask_TaskSubType) {
    Storage_ModelResourceTask_TaskSubType[Storage_ModelResourceTask_TaskSubType["TaskSubTypeNil"] = 0] = "TaskSubTypeNil";
    Storage_ModelResourceTask_TaskSubType[Storage_ModelResourceTask_TaskSubType["VideoTranscodeTypeFluHls"] = 1] = "VideoTranscodeTypeFluHls";
    Storage_ModelResourceTask_TaskSubType[Storage_ModelResourceTask_TaskSubType["VideoTranscodeTypeSdHls"] = 2] = "VideoTranscodeTypeSdHls";
    Storage_ModelResourceTask_TaskSubType[Storage_ModelResourceTask_TaskSubType["VideoTranscodeTypeHdHls"] = 3] = "VideoTranscodeTypeHdHls";
    Storage_ModelResourceTask_TaskSubType[Storage_ModelResourceTask_TaskSubType["VideoSnapshotTypeDefault"] = 100] = "VideoSnapshotTypeDefault";
  })(Storage_ModelResourceTask_TaskSubType || (Storage_ModelResourceTask_TaskSubType = {}));

  return Storage_ModelResourceTask_TaskSubType;
}();
export var Storage_GetStorageConfigListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Storage_GetStorageConfigListReq_ListOption;

  (function (Storage_GetStorageConfigListReq_ListOption) {
    Storage_GetStorageConfigListReq_ListOption[Storage_GetStorageConfigListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Storage_GetStorageConfigListReq_ListOption[Storage_GetStorageConfigListReq_ListOption["ListOptionCorpId"] = 1] = "ListOptionCorpId";
    Storage_GetStorageConfigListReq_ListOption[Storage_GetStorageConfigListReq_ListOption["ListOptionResourceType"] = 2] = "ListOptionResourceType";
  })(Storage_GetStorageConfigListReq_ListOption || (Storage_GetStorageConfigListReq_ListOption = {}));

  return Storage_GetStorageConfigListReq_ListOption;
}();
export var Storage_GetResourceListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Storage_GetResourceListReq_ListOption;

  (function (Storage_GetResourceListReq_ListOption) {
    Storage_GetResourceListReq_ListOption[Storage_GetResourceListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Storage_GetResourceListReq_ListOption[Storage_GetResourceListReq_ListOption["ListOptionType"] = 1] = "ListOptionType";
  })(Storage_GetResourceListReq_ListOption || (Storage_GetResourceListReq_ListOption = {}));

  return Storage_GetResourceListReq_ListOption;
}();
export var Storage_DetectType = function () {
  //__ENUM_IIFE__
  var Storage_DetectType;

  (function (Storage_DetectType) {
    Storage_DetectType[Storage_DetectType["DetectTypeNil"] = 0] = "DetectTypeNil";
    Storage_DetectType[Storage_DetectType["DetectTypePorn"] = 1] = "DetectTypePorn";
    Storage_DetectType[Storage_DetectType["DetectTypeTerrorism"] = 2] = "DetectTypeTerrorism";
    Storage_DetectType[Storage_DetectType["DetectTypePolitics"] = 4] = "DetectTypePolitics";
    Storage_DetectType[Storage_DetectType["DetectTypeAds"] = 8] = "DetectTypeAds";
  })(Storage_DetectType || (Storage_DetectType = {}));

  return Storage_DetectType;
}();
export var Storage_ImageAuditRsp_ResultType = function () {
  //__ENUM_IIFE__
  var Storage_ImageAuditRsp_ResultType;

  (function (Storage_ImageAuditRsp_ResultType) {
    Storage_ImageAuditRsp_ResultType[Storage_ImageAuditRsp_ResultType["ResultTypeNil"] = 0] = "ResultTypeNil";
    Storage_ImageAuditRsp_ResultType[Storage_ImageAuditRsp_ResultType["ResultTypePass"] = 1] = "ResultTypePass";
    Storage_ImageAuditRsp_ResultType[Storage_ImageAuditRsp_ResultType["ResultTypeBlock"] = 2] = "ResultTypeBlock";
    Storage_ImageAuditRsp_ResultType[Storage_ImageAuditRsp_ResultType["ResultTypeReview"] = 3] = "ResultTypeReview";
  })(Storage_ImageAuditRsp_ResultType || (Storage_ImageAuditRsp_ResultType = {}));

  return Storage_ImageAuditRsp_ResultType;
}();